export const clientInformationHeaders = [
  'Client Name',
  'Company',
  'Contact No.',
  'Project Name',
  'Public Official',
];
